import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import React from 'react';

export const sidebarWidth = '600px';

export const boxStyles = (open: boolean): SxProps<Theme> => {
  return {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    alignSelf: 'flex-start',
    right: 0,
    width: sidebarWidth,
    height: '100%',
    backgroundColor: 'white',
    border: '1px solid grey',
    borderRadius: '7px 0 0 7px',
    boxShadow: 3,
    zIndex: 10,
    padding: 0,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  };
};

export const titleBoxStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '40px',
  flex: '0 0 auto'
};

export const titleStyles: React.CSSProperties = {
  fontSize: '16px',
  fontWeight: '700',
  color: '#3D4047',
  paddingTop: '20px',
  paddingLeft: '20px',
  fontFamily: 'Circular Std Book'
};

export const noCategoricalColumnsStyles: React.CSSProperties = {
  fontSize: '14px',
  fontWeight: '450',
  color: '#EC5D57',
  fontFamily: 'Circular Std Book'
};

export const warningStyles: React.CSSProperties = {
  display: 'table',
  margin: '0 auto'
};

export const warningIconStyles: React.CSSProperties = {
  color: 'red',
  marginRight: '10px',
  padding: '0'
};

export const closeIconStyles: SxProps<Theme> = {
  position: 'absolute',
  width: '19px',
  height: '19px',
  color: '#76787F',
  right: '19px',
  top: '19px'
};

export const borderStyles: React.CSSProperties = {
  margin: '0px 30px',
  borderBottom: '1px solid #B3B5B9',
  borderTop: '1px solid #B3B5B9'
};

export const middleBlockStyles: React.CSSProperties = {
  height: '150px',
  overflowY: 'auto',
  overflowX: 'hidden',
  width: '100%',
  flex: '1'
};

export const wholeNewFileStyles: React.CSSProperties = { marginTop: '11px' };

export const newFileCheckboxLabelStyles: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '40px'
};

export const formControlStyles: SxProps<Theme> = {
  marginLeft: '0',
  marginRight: '0'
};

export const actionsOptionsParentStyles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  marginBottom: '10px'
};

export const radiobuttonRowStyles: React.CSSProperties = {
  padding: '11px 10px'
};

export const newFileNameInputStyles: React.CSSProperties = {
  marginLeft: '10px',
  width: '211px',
  height: '24px',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: '450',
  color: '#000', // Ensures user-typed text is black
  fontFamily: 'Circular Std Book',
  border: '1px solid #76787F',
  outline: 'none',
  padding: '5px 10px'
};

export const newFileNameSecondInputStyles: React.CSSProperties = {
  marginLeft: '10px',
  width: '200px',
  height: '24px',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: '450',
  color: '#000', // Ensures user-typed text is black
  fontFamily: 'Circular Std Book',
  border: '1px solid #76787F',
  outline: 'none',
  padding: '5px 10px'
};

export const parentActionRadioStyles: SxProps<Theme> = {
  padding: 0,
  '& .MuiSvgIcon-root': {
    fontSize: '16px'
  },
  '&.Mui-checked': {
    color: '#777777'
  },
  color: '#777777'
};

export const parentActionLabelStyles: React.CSSProperties = {
  fontSize: '14px',
  marginLeft: '6px',
  fontFamily: 'Circular Std Book',
  fontWeight: '450',
  color: '#777777'
};

export const newFileCheckboxStyles: React.CSSProperties = { marginRight: '10px' };

export const extensionErrorStyles: React.CSSProperties = {
  color: 'red',
  fontSize: '12px',
  fontWeight: '450',
  fontFamily: 'Circular Std Book',
  marginLeft: '270px',
  marginTop: '5px',
  marginBottom: '0'
};

export const scrollBlockStyles: React.CSSProperties = {
  minHeight: '150px',
  overflowY: 'auto',
  overflowX: 'hidden',
  width: '100%',
  flex: '1'
};
export const blockStyles: React.CSSProperties = {
  padding: '20px 40px 0 40px'
};

export const buttonsStyles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  flex: '0 0 auto',
  marginBottom: '20px',
  paddingTop: '20px'
};

// export const columnsAutocompleteLiStyles: React.CSSProperties = {
//   fontFamily: 'Circular Std Book',
//   fontSize: '12px',
//   color: '#777777',
//   fontWeight: 450
// };

export const columnsAutocompleteStyles: SxProps<Theme> = {
  minHeight: '40px',
  '& .MuiChip-root': {
    backgroundColor: 'rgb(250,250,250)',
    color: 'black !important',
    // border: '1px solid #D9D9D9',
    fontFamily: 'Circular Std Book !important'
  },
  '& .MuiChip-label': {
    fontFamily: 'Circular Std Book !important'
  },
  '& .MuiChip-deleteIcon': {
    fontSize: '16px', // Adjust the size to your preference
    width: '16px',
    height: '16px'
  },
  '& .MuiOutlinedInput-root': {
    padding: '0px',
    minHeight: '40px',
    border: '.5px solid #D9D9D9',
    borderRadius: '4px',

    '&:hover': {
      borderColor: '#D9D9D9'
    },
    '&.Mui-focused': {
      borderColor: '#D9D9D9'
    },
    '& fieldset': {
      border: 'none'
    }
  },
  // '& .MuiSvgIcon-root': {
  //   width: '24px',
  //   height: '24px',
  // },
  '& .MuiAutocomplete-listbox': {
    fontFamily: 'Circular Std Book !important'
  },
  '& .MuiInputBase-input': {
    fontSize: '14px'
  }
};

export const columnsAutocompleteLiStyles: React.CSSProperties = {
  fontFamily: 'Circular Std Book',
  fontSize: '14px',
  color: '#777777',
  fontWeight: 450,
  display: 'flex',
  alignItems: 'center'
  // padding: '8px 10px',
  // marginLeft: '0'
};

export const actionsAutocompleteIconStyles: React.CSSProperties = {
  width: '20px',
  height: '20px',
  marginRight: '6px',
  verticalAlign: 'middle', // Vertically align icons in the middle
  flexShrink: 0 // Prevent icons from shrinking
};

export const categoricalColumnsHintStyles: React.CSSProperties = {
  fontSize: '10px',
  fontStyle: 'italic',
  fontFamily: 'Circular Std Book',
  color: '#777777',
  fontWeight: 450,
  paddingLeft: '10px',
  paddingTop: '2px'
};

export const actionsAutocompletePlaceholderStyles: SxProps<Theme> = {
  '& .MuiInputBase-input::placeholder': {
    fontSize: '14px',
    fontFamily: 'Circular Std Book',
    color: '#777777',
    fontWeight: 450
  }
};

export const discardButtonStyles: React.CSSProperties = {
  width: '180px',
  height: '36px',
  backgroundColor: '#EEEFF1',
  color: '#000000',
  fontFamily: 'Circular Std Book',
  fontSize: '16px',
  fontWeight: '450px',
  borderRadius: '8px',
  marginRight: '28px',
  border: 'none',
  cursor: 'pointer'
};

export const discardButtonEnableStyles: React.CSSProperties = {
  width: '180px',
  height: '36px',
  backgroundColor: '#334063',
  color: '#ffffff',
  fontFamily: 'Circular Std Book',
  fontSize: '16px',
  fontWeight: '450px',
  borderRadius: '8px',
  marginRight: '28px',
  border: 'none',
  cursor: 'pointer'
};

export const saveButtonStyles = (isDisabled: boolean): React.CSSProperties => {
  return {
    width: '180px',
    height: '36px',
    backgroundColor: !isDisabled ? '#B3B5B9' : '#334063',
    color: '#ffffff',
    fontFamily: 'Circular Std Book',
    fontSize: '16px',
    fontWeight: '450px',
    borderRadius: '8px',
    border: 'none',
    cursor: !isDisabled ? 'default' : 'pointer'
  };
};
